import React from 'react';
import { Text, Pressable, StyleSheet } from 'react-native';
import { THEME } from '../../constants/styles';
import { OPComponent, PlusView, I18n } from '../components';

export default class AddAnotherButton extends OPComponent {
  render() {
    return (
      <Pressable style={styles.addAnotherButton} onPress={this.props.onPress}>
        <PlusView />
        <Text style={styles.addAnotherText}>{I18n.c1('invite.addAnother')}</Text>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  addAnotherButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 20,
  },
  addAnotherText: Object.assign({}, THEME.textRegularLight, {
    flex: 1,
    marginLeft: 15,
  }),
});
